import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-menu-copyright',
  templateUrl: './menu-copyright.component.html',
  styleUrls: ['./menu-copyright.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class MenuCopyrightComponent {
  readonly copyrightStartYear = 2025;
  copyrightRange: string = new Date().getFullYear().toString();

  constructor() {
    this.setupCopyrightRange();
  }

  setupCopyrightRange(): void {
    const currentYear = new Date().getFullYear();

    if (this.copyrightStartYear < currentYear) {
      this.copyrightRange = this.formatCopyrightRange(
        this.copyrightStartYear,
        currentYear
      );
    }
  }

  private formatCopyrightRange(startYear: number, endYear: number): string {
    if (Math.floor(startYear / 10) === Math.floor(endYear / 10)) {
      return `${startYear}-${endYear.toString().slice(-2)}`;
    }

    return `${startYear}-${endYear}`;
  }
}
